import { CommonModule } from '@angular/common';
import {ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {ExamService} from "../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {
  faCaretDown,
  faChevronLeft,
  faChevronRight,
  faCaretUp,
  faPenToSquare,
  faEye, faCross, faX, faChevronUp, faChevronDown, faTrash
} from "@fortawesome/free-solid-svg-icons";
import {DropdownMenuComponent, MenuItem} from "../../../shared/ui/dropdown-menu/dropdown-menu.component";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../shared/ui/outline-button/outline-button.component";
import {MatSnackBar} from "@angular/material/snack-bar";
import {APIResponse} from "../../../shared/data-access/api-response.model";
import {FormsModule} from "@angular/forms";
import {MatIconModule} from "@angular/material/icon";
import {FullButtonComponent} from "../../../shared/ui/full-button/full-button.component";
import {ExamPreviewResponse, Parts, Question} from "../exam-take/exam-take.component";
import { DropdownSearchComponent } from 'src/app/shared/ui/dropdown-search/dropdown-search.component';
import {BreadcrumbComponent, BreadcrumbNavigation} from "../../../shared/ui/breadcrumb/breadcrumb.component";
import {CodeEditorComponent} from "../../../shared/ui/code-editor/code-editor.component";
import { AudioPlaybackComponent } from "../../../shared/ui/problem-templates/audio-playback/audio-playback.component";
import { DecimalComponent } from 'src/app/shared/ui/problem-templates/decimal/decimal.component';
import { FormulaComponent } from 'src/app/shared/ui/problem-templates/formula/formula.component';
import { MultifieldComponent } from 'src/app/shared/ui/problem-templates/multifield/multifield.component';
import { MultipleChoiceComponent } from 'src/app/shared/ui/problem-templates/multiplechoice/multiplechoice.component';
import { TextareaComponent } from 'src/app/shared/ui/problem-templates/textarea/textarea.component';
import { GroupingComponent } from "src/app/shared/ui/problem-templates/grouping/grouping.component";
import {AuthService} from "../../../login/data-access/auth.service";
import {Subscription} from "rxjs";

interface ExtendedParts extends Parts {
  isExpanded: boolean
}
interface SubmissionReviewResponse extends ExamPreviewResponse {
  parts: ExtendedParts[]
}
@Component({
    selector: 'exam-submissions-review',
    templateUrl: './exam-submission-review.component.html',
    styleUrls: ['../list/list.component.css'],
    imports: [CommonModule, FontAwesomeModule, DropdownMenuComponent, OutlineButtonComponent, DropdownSearchComponent, FormsModule, MatIconModule, FullButtonComponent, BreadcrumbComponent, CodeEditorComponent, DecimalComponent, FormulaComponent, MultifieldComponent, MultipleChoiceComponent, TextareaComponent, AudioPlaybackComponent, GroupingComponent]
})
export class ExamSubmissionReviewComponent implements OnInit {
  constructor(examService: ExamService, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {}
  router = inject(Router)
  examService = inject(ExamService)
  _snackBar = inject(MatSnackBar)
  examUUID = ''
  examID = -1
  submissionReview: SubmissionReviewResponse | null = null
  openChangeScore = false
  openPartChangeScore = false
  openQuestionDetails = false
  faCaretDown = faCaretDown
  faPenToSquare = faPenToSquare
  questionToBeDetailed: Question | null = null
  studentName = ''
  newCorrectness: number | null = null
  newPartScore: number | null = null
  changeQuestionPartPosition: number = -1
  changeQuestionPosition: number = -1
  changePartScorePosition: number = -1
  examTitle: string = ''
  breadcrumbNav: BreadcrumbNavigation[] = [{
    text: 'Exam List',
    route: 'dashboard/exam/list'
  }, {
    text: 'Exam Instances',
    route: 'dashboard/exam/instances'
  }]
  isStudent = false
  authService = inject(AuthService);
  examAdmin = false
  openConfirmDeleteExamPart = false
  deletePartID = -1
  username = ''
  deletePartIndex = -1


  userPermissionSub: Subscription = this.authService.userDashboard$.subscribe((user) => {
    this.examAdmin = user.result.some(el => el.ui === 'ExamAdmin')
  })

  ngOnInit() {
    this.isStudent = this.router.url.indexOf('ViewGrade') > -1
    this.route.queryParams.subscribe((params) => {
      if(params['exam_uuid']) {
        this.examUUID = params['exam_uuid']
        this.getReviewExamInstance()
      }
      if(params['exam_id']) {
        this.examID = params['exam_id']
      }
      if(params['exam_title']) {
        this.examTitle = params['exam_title']
      }
      if(params['display_name']) {
        this.studentName = params['display_name']
      }
      if(params['username']) {
        this.username = params['username']
      }
      this.breadcrumbNav[1].queryParams = {queryParams: {exam_id: this.examID, exam_title: this.examTitle}}
    })
  }

  getReviewExamInstance() {
    this.examService.reviewExamInstance(this.examUUID, this.isStudent).subscribe((response) => {
      if(response.success) {
        this.submissionReview = response.result
      } else {
        this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
      }
    })
  }

  togglePartExpansion(part: ExtendedParts) {
    if (part.isExpanded) {
      part.questions.forEach((question) => {
        if ((question.question.type === 'RECORD_AUDIO' || question.question.type === 'UPLOAD_DOC') &&
            question.question.recordedAnswer) {
          this.getQuestionURL(part.part_position, question.question_position);
        }
      });
    }
  }

  getQuestionURL(partPosition: number, questionPosition: number) {
    this.examService.downloadAnswer(this.examUUID, partPosition, questionPosition).subscribe((response: any) => {
      if (response.size > 0) {
        const audioUrl = URL.createObjectURL(response);
        this.submissionReview!.parts[partPosition].questions[questionPosition].question.recordedAnswer = audioUrl;
        this.cdr.detectChanges();
      }
    });
  }

  getAudioUrl(partPosition: number, questionPosition: number): string {
    return this.submissionReview?.parts[partPosition]?.questions[questionPosition]?.question.recordedAnswer || '';
  }

  examList() {
    this.router.navigate(['dashboard/exam/list'])
  }

  examSubmissions() {
    this.router.navigate(['dashboard/exam/instances'], {queryParams: {exam_id: this.examID, exam_title: this.examTitle}})
  }

  cancelChangeScore() {
    this.changeQuestionPosition = -1
    this.changeQuestionPartPosition = -1
    this.newCorrectness = null
    this.openChangeScore = false
  }

  changeScore(question_position: number, part_position: number) {
    this.changeQuestionPosition = question_position
    this.changeQuestionPartPosition = part_position
    this.openChangeScore = true
  }

  questionDetails(question: Question) {
    this.questionToBeDetailed = question
    this.openQuestionDetails = true
  }

  saveChangeScore() {
    if(this.newCorrectness == null) {
      this._snackBar.open('Correctness cannot be blank', 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
    } else if(this.newCorrectness < 0 || this.newCorrectness > 1) {
      this._snackBar.open('Correctness must be between 0.0 and 1.0', 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
    } else if(this.changeQuestionPosition !== -1 && this.changeQuestionPartPosition !== -1) {
      this.examService.overwriteSingleQuestionCorrectness(this.examUUID, this.changeQuestionPartPosition, this.changeQuestionPosition, this.newCorrectness)
        .subscribe((response) => {
          if(response.success) {
            this._snackBar.open('Correctness successfully updated!', 'Dismiss', {duration: 5000})
            this.getReviewExamInstance()
            this.cancelChangeScore()
          } else {
            this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
          }
        })
    }
  }

  openChangePartDialog(part_position: number) {
    this.changePartScorePosition = part_position
    this.openPartChangeScore = true
  }

  cancelChangePartScore() {
    this.openPartChangeScore = false
    this.changePartScorePosition = -1
    this.newPartScore = null
  }

  saveChangePartScore() {
    // TODO check part position
    if(this.newPartScore != null && this.newPartScore >= 0) {
      this.examService.overwritePartScore(this.examUUID, this.changePartScorePosition, this.newPartScore).subscribe((response) => {
        if (response.success) {
          this._snackBar.open('Part score successfully updated!', 'Dismiss', {duration: 5000})
          this.getReviewExamInstance()
          this.cancelChangePartScore()
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
        }
      })
    } else {
      this._snackBar.open('New score must be >= 0', 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
    }
  }

  checkForHTMLTags(test?: string): boolean {
    if(test != null)
      return /<\/?[a-z][\s\S]*>/i.test(test)
    else
      return false
  }

  confirmDeleteExamPart() {
    if(this.deletePartID !== -1 && this.deletePartID !== -1) {
      this.examService.removeExamPartInstance(this.deletePartID).subscribe((response) => {
        if (response.success) {
          this._snackBar.open('Part successfully removed', 'Dismiss', {duration: 5000})
          this.deletePartID = -1
          this.openConfirmDeleteExamPart = false
          this.submissionReview?.parts.splice(this.deletePartIndex, 1)
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {duration: 5000, panelClass: ['error-snackbar']})
        }
      })
    }
  }

  protected readonly faX = faX;
  protected readonly faChevronUp = faChevronUp;
  protected readonly faChevronDown = faChevronDown;
  protected readonly faTrash = faTrash;
}
